"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleHref = exports.getSortedLocaleOptions = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
function getSortedLocaleOptions(localeOptions = [], locale, defaultString) {
    if (!localeOptions || !Array.isArray(localeOptions)) {
        console.error('Locale options will not render correctly! Expecting an array of objects containing both [name] and [lang] keys!');
    }
    let currentLocaleName = defaultString;
    let activeLocale;
    localeOptions.forEach((l) => {
        if (l.lang === locale) {
            activeLocale = l;
        }
    });
    if (locale && activeLocale) {
        currentLocaleName = activeLocale.name;
    }
    const sortedLocaleOptions = localeOptions.sort((localeA, localeB) => {
        const a = localeA && typeof localeA.lang === 'string' ? localeA.lang.toLowerCase() : '';
        const b = localeB && typeof localeB.lang === 'string' ? localeB.lang.toLowerCase() : '';
        if (a > b)
            return 1;
        if (a < b)
            return -1;
        return 0;
    });
    return { currentLocaleName, sortedLocaleOptions };
}
exports.getSortedLocaleOptions = getSortedLocaleOptions;
const getLocaleHref = (localeOption, locale) => {
    const { pageSlug } = (0, epic_games_nav_shared_1.extractSlugLocale)(window_or_global_1.default.location.pathname || '', locale);
    const lang = localeOption.lang.replace(/_/, '-');
    const { context = '', wholePath = '' } = (0, epic_games_nav_shared_1.getHrefWithLocale)({ href: pageSlug, hrefGenerator: localeOption.customHref, locale: lang });
    const href = `${context}${wholePath}`;
    let url = `${href}${window_or_global_1.default.location.search || ''}`;
    if (url.indexOf('lang=') > -1) {
        url = url.replace(/lang=[\w_-]*/, `lang=${lang}`);
    }
    else if (url.indexOf('?') > -1) {
        url += `&lang=${lang}`;
    }
    else {
        url += `?lang=${lang}`;
    }
    return url + window_or_global_1.default.location.hash || '';
};
exports.getLocaleHref = getLocaleHref;
//# sourceMappingURL=localeUtils.js.map